const WRITER_IMG = "/images/derek-fee.jpg";

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <p className="text-rose-700 uppercase tracking-[0.3em] text-sm font-bold">
              The Author
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-white mt-3 tracking-tight">
              About Derek Fee
            </h2>
            <div className="space-y-5 mt-8">
              <p className="text-zinc-400 text-base md:text-lg leading-relaxed">
                Derek Fee is an acclaimed Irish crime thriller author and the creator of two
                beloved detective series: The Belfast Murders, a twelve-novel saga following
                Detective Inspector Wilson through the dark underbelly of Northern Ireland,
                and The Galway Murders, featuring DI Fiona Madden's investigations across the
                treacherous landscapes of Connemara and the west of Ireland.
              </p>
              <p className="text-zinc-400 text-base md:text-lg leading-relaxed">
                With over twenty published crime novels, Derek Fee has established himself as
                one of Ireland's most compelling crime fiction voices. His work spans police
                procedural, political thriller, action, and supernatural sub-genres — each
                novel drawing from Ireland's rich cultural landscape to create detective fiction
                that readers worldwide describe as "impossible to put down." A testament to the
                power of independent publishing, his dedicated readership continues to grow
                with each new release.
              </p>
            </div>
            <div className="blood-accent pl-6 mt-8">
              <p className="text-zinc-300 italic text-base leading-relaxed">
                "Masterfully written, engaging, convoluted plots and richly tapestried,
                fully-fleshed characters."
              </p>
              <p className="text-zinc-500 text-sm mt-2">— Reader Review</p>
            </div>
          </div>
          <div className="relative">
            <div className="noir-glow">
              <img
                src={WRITER_IMG}
                alt="Derek Fee, Irish crime thriller author"
                className="w-full object-cover aspect-[4/5]"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-l-2 border-b-2 border-rose-700/40" />
            <div className="absolute -top-4 -right-4 w-24 h-24 border-r-2 border-t-2 border-rose-700/40" />
          </div>
        </div>
      </div>
    </section>
  );
}
